"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRadioButton = exports.GroupOptions = exports.GroupTitle = exports.GroupWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _LabeledRadio = _interopRequireDefault(require("../LabeledRadio"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupWrapper = _styledComponents.default.div.withConfig({
  displayName: "LabeledRadioGroupstyles__GroupWrapper",
  componentId: "kswweo-0"
})(["padding:0;"]);

exports.GroupWrapper = GroupWrapper;

var GroupTitle = _styledComponents.default.div.withConfig({
  displayName: "LabeledRadioGroupstyles__GroupTitle",
  componentId: "kswweo-1"
})(["line-height:1.1875rem;font-weight:", ";display:inline-block;margin-bottom:", ";"], function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', props.theme.standardPadding, '.5');
});

exports.GroupTitle = GroupTitle;

var GroupOptions = _styledComponents.default.div.withConfig({
  displayName: "LabeledRadioGroupstyles__GroupOptions",
  componentId: "kswweo-2"
})(["display:flex;flex-wrap:wrap;"]);

exports.GroupOptions = GroupOptions;
var StyledRadioButton = (0, _styledComponents.default)(_LabeledRadio.default).withConfig({
  displayName: "LabeledRadioGroupstyles__StyledRadioButton",
  componentId: "kswweo-3"
})(["min-width:50%;"]);
exports.StyledRadioButton = StyledRadioButton;